import Repository from '@/api/Repository'

const resource = '/object'

export default {
  index(params) {
    // return Repository.get(`${resource}`, {}, {
    //   params,
    // })

    // eslint-disable-next-line no-param-reassign
    if (params.father_id === 0) params.father_id = null
    return Repository.get(resource, {
      params,
    })
  },
  indexStaging() {
    return Repository.get(resource, {
      params: {
        only_staging_ftp: true,
      },
    })
  },
  indexTrashed() {
    return Repository.get(resource, {
      params: {
        only_trashed: true,
      },
    })
  },
  show(id) {
    return Repository.get(`${resource}/${id}`)
  },
  update(id, data) {
    return Repository.put(`${resource}/${id}`, data)
  },
  create(data, config = {}) {
    return Repository.post(resource, data, config)
  },
  delete(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  getDirs(id) {
    let url = `${resource}/dirs`
    if (id !== null && id !== undefined) {
      url += `/${id}`
    }
    return Repository.get(url)
  },
  createDir(data) {
    return Repository.post(`${resource}/dir`, {
      label: data.label,
      father_id: data.father_id,
    })
  },
  makeCopy(id, data) {
    return Repository.post(`${resource}/copy/${id}`, data)
  },
  move(data) {
    return Repository.post(`${resource}/move/`, data)
  },
  download(uuid) {
    return Repository.get(`${resource}/get-download-link/${uuid}`)
  },
  newVersion(id, data, config = {}) {
    return Repository.post(`${resource}/new_version/${id}`, data, config)
  },
  uploadLimit() {
    return Repository.get(`${resource}/upload-limit`)
  },
  setPermission(data) {
    return Repository.post(`${resource}/set-permissions`, data)
  },
  multipleDelete(data) {
    return Repository.delete(`${resource}/deleteMultiple`, { data })
  },
  restore(id, data) {
    return Repository.post(`${resource}/restore/${id}`, data)
  },
  setExpiration(id, expirationDate) {
    return Repository.post(`${resource}/${id}/expiration`, {
      expiration_date: expirationDate,
    })
  },
  removeExpiration(id) {
    return Repository.delete(`${resource}/${id}/expiration`)
  },
  deletedReport(params) {
    return Repository.get(`${resource}/deleted-report`, {
      params,
    })
  },
}
